export default class OrderRequestCartItem {
  constructor ({ id, quantity, addons, customFields }) {
    this.id = id
    this.quantity = quantity
    this.addons = addons
    this.customFields = customFields
  }
}
